"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : STATE : EMPTY --------------- ++++++++++ */


var _default = {
  emptystate: {
    textAlign: 'center',
    '& .illustration': {
      opacity: '0',
      animationName: 'rotateIn',
      animationDelay: '.2s',
      animationDuration: '.5s',
      animationFillMode: 'forwards',
      margin: (0, _index.replacePXinStringWithEM)("50px auto 30px")
    },
    '& .bodycopy': {
      opacity: '0',
      animationName: 'fadeInUp',
      animationDelay: '.3s',
      animationDuration: '.2s',
      animationFillMode: 'forwards',
      maxWidth: (0, _index.pxToEm)(655),
      marginBottom: (0, _index.pxToEm)(40),
      '& p': {
        fontSize: (0, _index.pxToEm)(22),
        '& .accent': {
          color: _index.theme.color.primary.medium.swatch,
          opacity: '1'
        }
      }
    },
    '& .ctas': {
      opacity: '0',
      animationName: 'fadeInUp',
      animationDelay: '.5s',
      animationDuration: '.2s',
      animationFillMode: 'forwards',
      '& .button': {
        width: 'auto'
      }
    }
  }
};
exports.default = _default;